import { Button } from 'components/atoms/Button';
import globalModalsController from 'components/organisms/GlobalModalsService/globalModalsController';
import { worldThemeContext } from 'hooks/shared/useWorldTheme';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  onClose?: () => void;
  onConfirm?: () => void;
  fieldNames: string[];
};

// profile.firstName.label
// profile.lastName.label
// profile.companyName.label
// profile.IBAN.label
// profile.VATNumber.label

const Content: FC<Props> = ({ onClose, onConfirm, fieldNames }) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="text-primary-800 font-semibold mb-4">
        <p>{t('user.verificaion.reset.warning.text1')}</p>
        <ul className="list-disc list-inside">
          {fieldNames.map((name) => (
            <li key={name} className="text-primary-700">
              {t(`profile.${name}.label`)}
            </li>
          ))}
        </ul>
        <p>{t('user.verificaion.reset.warning.text2')}</p>
      </div>
      <div className="flex flex-col gap-4">
        <Button onClick={onConfirm}>
          {t('user.verificaion.reset.warning.confirm')}
        </Button>
        <Button structure="text" onClick={onClose}>
          {t('user.verificaion.reset.warning.cancel')}
        </Button>
      </div>
    </div>
  );
};

type WarningProps = {
  fieldNames: string[];
  id: string;
};

export const peppolDeactivationGlobalWarning = (
  props: WarningProps,
): Promise<void> => {
  return new Promise((resolve, reject) => {
    globalModalsController.openModal({
      id: props.id,
      render: (api) => (
        <worldThemeContext.Provider value="taxes">
          <Content
            fieldNames={props.fieldNames}
            onClose={() => api.closeModal()}
            onConfirm={() => {
              resolve();
              api.closeModal();
            }}
          />
        </worldThemeContext.Provider>
      ),
      options: {
        color: 'taxes',
        name: 'peppol deactivation warning',
        onClose: () => reject(),
      },
    });
  });
};
